var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "app-main-content",
      attrs: {
        "element-loading-text": "Loading...",
        "element-loading-spinner": "el-icon-loading",
        "element-loading-background": "rgba(170,170,170,0.5)"
      }
    },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c(
              "search-item",
              {
                ref: "searchItem",
                attrs: {
                  "config-module": "302",
                  "custom-sim-query-placeholder":
                    _vm.$t("CargoMsg.Cargo_PlsInput") +
                    " : " +
                    _vm.$t("SeaExport.OrderNo2"),
                  "custom-search-items": _vm.customSearchItems,
                  no: "1"
                },
                on: {
                  "click-more": function(value) {
                    _vm.isAdvancedQuery = value
                  },
                  simSearchItemCallBack: _vm.toSimpleQuery,
                  advSearchItemCallBack: _vm.toAdvancedQuery
                }
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "operations" }, slot: "operations" },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["button_fmRailwayBoxTube_buyContainer"],
                            expression:
                              "['button_fmRailwayBoxTube_buyContainer']"
                          }
                        ],
                        attrs: { no: "BuyContainer", type: "primary" },
                        on: { click: _vm.buyContainerClickHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("RailwayExport.BuyContainer")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["button_fmRailwayBoxTube_sellContainer"],
                            expression:
                              "['button_fmRailwayBoxTube_sellContainer']"
                          }
                        ],
                        attrs: { no: "SellContainer", type: "primary" },
                        on: { click: _vm.sellContainerClickHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("RailwayExport.SellContainer")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["button_fmRailwayBoxTube_rentContainer"],
                            expression:
                              "['button_fmRailwayBoxTube_rentContainer']"
                          }
                        ],
                        attrs: { no: "RentContainer", type: "primary" },
                        on: { click: _vm.rentContainerClickHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("RailwayExport.RentContainer")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["button_fmRailwayBoxTube_editContainer"],
                            expression:
                              "['button_fmRailwayBoxTube_editContainer']"
                          }
                        ],
                        attrs: { no: "Edit", type: "primary" },
                        on: { click: _vm.editClickHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("RailwayExport.Edit")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["button_fmRailwayBoxTube_deleteContainer"],
                            expression:
                              "['button_fmRailwayBoxTube_deleteContainer']"
                          }
                        ],
                        attrs: { no: "Delete", type: "primary" },
                        on: { click: _vm.deleteClickHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("RailwayExport.Delete")))]
                    ),
                    _vm.isShow
                      ? _c("micro-app", {
                          attrs: {
                            name: "child-vue2",
                            url: _vm.$store.getters.frontEndPluginUrl + "/",
                            "router-mode": "pure",
                            destroy: "",
                            data: _vm.getSelectData()
                          },
                          on: { datachange: _vm.handleDataChange }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "section grid-wrapper" },
              [
                _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": "170002",
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData,
                    no: "2"
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.gridApi = params.api
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("cargo-pagination", {
                  attrs: {
                    "config-module": "170002",
                    total: _vm.total,
                    page: _vm.pageNum,
                    limit: _vm.pageSize,
                    no: "3"
                  },
                  on: {
                    "update:page": function($event) {
                      _vm.pageNum = $event
                    },
                    "update:limit": function($event) {
                      _vm.pageSize = $event
                    },
                    pagination: _vm.toQuery
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("box-operation-dialog", {
        attrs: {
          visible: _vm.boxOperationDialog.visible,
          title: _vm.boxOperationDialog.title,
          "order-type": _vm.boxOperationDialog.orderType,
          "is-edit": _vm.boxOperationDialog.isEdit,
          railway: _vm.boxOperationDialog.railway,
          no: "4"
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.boxOperationDialog, "visible", $event)
          },
          resultFunction: _vm.toQuery
        }
      }),
      _c("selling-box-dialog", {
        attrs: {
          visible: _vm.sellingBoxDialog.visible,
          "railway-list": _vm.sellingBoxDialog.railwayList,
          no: "5"
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.sellingBoxDialog, "visible", $event)
          },
          resultFunction: _vm.toQuery
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }